"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBER_FILTER = exports.OPTIMIZATION_TYPE = exports.SOURCE = exports.COLUMN_TYPE = void 0;
/**
 * Column variable type
 */
var COLUMN_TYPE;
(function (COLUMN_TYPE) {
    COLUMN_TYPE["INTEGER"] = "integer";
    COLUMN_TYPE["FLOAT"] = "float";
    COLUMN_TYPE["DECIMAL"] = "decimal";
    COLUMN_TYPE["STRING"] = "string";
    COLUMN_TYPE["BOOLEAN"] = "boolean";
})(COLUMN_TYPE = exports.COLUMN_TYPE || (exports.COLUMN_TYPE = {}));
var SOURCE;
(function (SOURCE) {
    SOURCE["WEB"] = "WEB";
    SOURCE["MOBILE"] = "MOBILE";
})(SOURCE = exports.SOURCE || (exports.SOURCE = {}));
var OPTIMIZATION_TYPE;
(function (OPTIMIZATION_TYPE) {
    OPTIMIZATION_TYPE["PARTITION"] = "PARTITION";
    OPTIMIZATION_TYPE["BACKTRACK_TIME"] = "BACKTRACK_TIME";
    OPTIMIZATION_TYPE["INDEX"] = "INDEX";
})(OPTIMIZATION_TYPE = exports.OPTIMIZATION_TYPE || (exports.OPTIMIZATION_TYPE = {}));
var NUMBER_FILTER;
(function (NUMBER_FILTER) {
    NUMBER_FILTER["GREATER_THAN"] = "GREATER_THAN";
    NUMBER_FILTER["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
    NUMBER_FILTER["LESS_THAN"] = "LESS_THAN";
    NUMBER_FILTER["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
    NUMBER_FILTER["IS"] = "IS";
    NUMBER_FILTER["IS_NOT"] = "IS_NOT";
})(NUMBER_FILTER = exports.NUMBER_FILTER || (exports.NUMBER_FILTER = {}));
